import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { GameService } from 'src/app/services/game/game.service';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';

@Component({
  selector: 'app-modal-public-game',
  templateUrl: './modal-public-game.component.html',
  styleUrls: ['./modal-public-game.component.css']
})
export class ModalPublicGameComponent implements OnInit {
  accion = 0;
  @Input() id = null;
  dataUser: any;
  token = "";
  consulta = ""
  state_premium = 1;
  url = "";
  iframe = "";
  clave = "";
  iframe1 = '<iframe width="180" height="315" src="';
  iframe2 = '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';


  //paso = 1;
  espera = false;
  esperaFinal = false;
  @Output() saveButton = new EventEmitter<Object>();


  constructor(
    private gameService: GameService,
    private userService: UsuarioService
  ) { }
  ngOnInit(): void {
    /* this.id = parseInt(localStorage.getItem('idgame')); */
    let data = this.userService.getLocalStorage();
    this.dataUser = data['user'];
    this.token = data['token'];
    this.gameService.validarGame(this.token, this.id).subscribe(res => {
      if (res['status'] === 'success') {
        this.url = res["url"];
        this.iframe = this.iframe1 + this.url + this.iframe2;
      }else{
        this.publicar();
      }
    });
  }
  publicar() {
    this.gameService.generateGame(this.token, this.id).subscribe(res => {
      if (res['status'] === 'success') {
        this.url = res["url"];
        this.iframe = this.iframe1 + this.url + this.iframe2;
      } else {
      }
    });

  }

  createClave() {
    let body = {
      "campo": 'clave',
      "dato": this.clave
    };

    this.gameService.createClave(this.token, this.id, body).subscribe(res => {
      if (res['status'] === 'success') {
        //this.url = res["url"];
        //this.iframe = this.iframe1 + this.url + this.iframe2;

        //window.open(res["url"]);
        //this.getData();
      } else {
      }
    });
  }


  continuePaso(acciones) {
    this.accion = acciones;
    this.state_premium++;
    this.espera = true;
  }


  validate() {
    this.state_premium++;
    this.espera = true;


    /*
    if (this.accion == 1) {
      this.creacion_archivo = false;
      //si la accion es 3 crea el avatar con la funccion createCharactaresGallery
    } if (this.accion == 3) {
      let body = {
        "id": this.select_avatar
      };
      this.createCharactaresGallery(body);
    } else {
      this.creacion_caleria = true;
      this.allCharactares();
    }*/
  }
  back() {
    this.state_premium--;
    this.accion = 0;
    this.espera = false
  }

  finalized() {
    this.saveButton.emit({
      type: "finalized",
      value: this.accion
    })
  }

  close() {
    this.saveButton.emit({
      type: "close",
      value: ""
    })
  }


}
